const nav = [
  {
    title: "Home",
    link: "home",
  },
  {
    title: "Projects",
    link: "projects",
  },
  {
    title: "Resume",
    link: "resume",
  },
  {
    title: "Skills",
    link: "skills",
  },
  {
    title: "Contact",
    link: "contact",
  },
  // {
  //   title: "Blog",
  //   link: "blog",
  //   external: true,
  // }
];

export default nav;